module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n9r7n4r-ffc2668732feda5cba3972b447215ac9.svg";